import { render, staticRenderFns } from "./SectionDetail.vue?vue&type=template&id=054b7392&"
import script from "./SectionDetail.vue?vue&type=script&lang=js&"
export * from "./SectionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports